import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { applyStoredTheme } from '@weapps/design'
import { trpc, trpcClient } from './trpc'
import { router } from './router'
import './index.css'

// Keep the theme in step with the shared preference at runtime (the pre-paint script in index.html sets the
// initial data-theme before first paint; this follows live OS changes when the pref is `system`).
applyStoredTheme()

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </trpc.Provider>
  </React.StrictMode>,
)
